export enum CharacterType {
  None = "none",
  INR = "INR",
  INS = "INS",
  AOP = "AOP",
  AOB = "AOB",
  ADO = "ADO",
}
